import { render } from "./UserMasterDataManager.vue?vue&type=template&id=fbfb0dbc"
import script from "./UserMasterDataManager.vue?vue&type=script&lang=js"
export * from "./UserMasterDataManager.vue?vue&type=script&lang=js"

import exportComponent from "D:\\PHPStormProjects\\hqam-customer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__